import React, { ReactNode } from 'react';
import { useBrand } from '../../../app/config/brand';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'text' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  icon?: React.FC<{ className?: string }>;
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', size = 'md', className = '', icon: Icon, disabled, ...props }) => {
  const brand = useBrand();

  const baseStyles = "font-medium rounded-full transition-all duration-200 flex items-center justify-center gap-2";
  const sizes = {
    sm: "px-4 py-1.5 text-sm",
    md: "px-6 py-2.5 text-sm",
    lg: "px-8 py-3 text-base",
  };

  const getStyles = () => {
    if (disabled) {
      return { backgroundColor: brand.colors.border, color: brand.colors.textMuted, cursor: 'not-allowed' };
    }
    if (variant === 'primary') {
      return { backgroundColor: brand.colors.primary, color: brand.colors.onPrimary };
    }
    if (variant === 'secondary') {
      return { backgroundColor: 'transparent', color: brand.colors.link, border: `2px solid ${brand.colors.primary}` };
    }
    return { backgroundColor: 'transparent', color: brand.colors.link };
  };

  return (
    <button
      className={`${baseStyles} ${sizes[size]} ${className}`}
      style={getStyles()}
      disabled={disabled}
      {...props}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {children}
    </button>
  );
};
